/* Section menu (section wu-section-nav). Instance settings: window.WU_CFG[section id]. */
  (function () {
    function initOne(root) {
      if (!root || root.dataset.init) return;
      var C = (window.WU_CFG || {})[root.id] || {}, T = C.t || {};
      root.dataset.init = '1';
      var mine = root.closest('.shopify-section'), list = root.querySelector('.wu-snav__list'), nav = root.querySelector('.wu-snav__nav');
      var off = [];
      var on = function (t, type, fn, opt) { t.addEventListener(type, fn, opt); off.push(function () { t.removeEventListener(type, fn, opt); }); };
      /* skip / rename: section key (part of the id after “__”) or the original heading */
      var skip = (root.dataset.exclude || '').split(/[\n,;|]+/).map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean);
      var names = {};
      (root.dataset.labels || '').split(/[\n|]/).forEach(function (l) {
        var i = l.indexOf(':'); if (i > 0) names[l.slice(0, i).trim().toLowerCase()] = l.slice(i + 1).trim();
      });
      var links = [], secs = [], tops = [];
      function following() {
        if (!mine || !mine.parentElement) return [];
        return [].filter.call(mine.parentElement.children, function (sec) {
          return sec.classList.contains('shopify-section') && !!(mine.compareDocumentPosition(sec) & Node.DOCUMENT_POSITION_FOLLOWING);
        });
      }
      function build() {
        var cur = (list.querySelector('.is-active') || {}).dataset;
        list.innerHTML = ''; links = []; secs = [];
        following().forEach(function (sec) {
          if (!sec.offsetHeight) return;
          var key = sec.id.split('__').pop().toLowerCase();
          var h = sec.querySelector('h1, h2, h3, .heading, h4');
          var head = h ? h.textContent.replace(/\s+/g, ' ').trim() : '';
          if (skip.indexOf(key) > -1 || (head && skip.indexOf(head.toLowerCase()) > -1)) return;
          var label = names[key] || names[head.toLowerCase()] || head;
          if (!label) return;
          var li = document.createElement('li'), a = document.createElement('a');
          a.href = '#' + sec.id; a.className = 'wu-snav__link'; a.dataset.target = sec.id; a.textContent = label;
          li.appendChild(a); list.appendChild(li); links.push(a); secs.push(sec);
        });
        root.hidden = links.length === 0;
        if (cur && cur.target) links.forEach(function (l) { l.classList.toggle('is-active', l.dataset.target === cur.target); });
        measure();
      }
      function measure() {
        var y = window.scrollY;
        tops = secs.map(function (s) { return s.getBoundingClientRect().top + y; });
        schedule();
      }
      var ticking = false, last = -1;
      function schedule() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
      function update() {
        ticking = false;
        var line = window.scrollY + mine.getBoundingClientRect().bottom + 40, cur = -1;
        tops.forEach(function (t, i) { if (t <= line) cur = i; });
        if (cur < 0 && links.length) cur = 0;
        links.forEach(function (l, i) {
          var act = i === cur;
          l.classList.toggle('is-active', act);
          if (act) l.setAttribute('aria-current', 'location'); else l.removeAttribute('aria-current');
        });
        /* on mobile scroll the bar so the selected item is visible */
        if (cur !== last && links[cur] && nav.scrollWidth > nav.clientWidth) {
          var a = links[cur];
          nav.scrollTo({ left: a.offsetLeft - (nav.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' });
        }
        last = cur;
      }
      /* click: scroll below the bar; scrolling up also shows the header → add its height */
      on(root, 'click', function (e) {
        var a = e.target.closest('.wu-snav__link'); if (!a) return;
        var el = document.getElementById(a.dataset.target); if (!el) return;
        e.preventDefault();
        var y = el.getBoundingClientRect().top + window.scrollY, up = y < window.scrollY;
        var hh = up ? (parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--sticky-header-height')) || 0) : 0;
        window.scrollTo({ top: y - mine.offsetHeight - hh + 1, behavior: 'smooth' });
      });
      on(window, 'scroll', schedule, { passive: true });
      var rz = 0;
      function remeasure() { clearTimeout(rz); rz = setTimeout(measure, 120); }
      on(window, 'resize', remeasure, { passive: true });
      on(window, 'load', build);
      var rb = 0;
      function rebuild() { clearTimeout(rb); rb = setTimeout(build, 150); }
      if ('ResizeObserver' in window) {
        var heights = new WeakMap();
        var ro = new ResizeObserver(function (entries) {
          var changed = entries.some(function (e) { var was = heights.get(e.target) || 0, now = e.target.offsetHeight; heights.set(e.target, now); return (was === 0) !== (now === 0); });
          if (changed) rebuild(); else remeasure();
        });
        following().forEach(function (sec) { heights.set(sec, sec.offsetHeight); ro.observe(sec); });
        off.push(function () { ro.disconnect(); });
      }
      if (mine && mine.parentElement && 'MutationObserver' in window) {
        var mo = new MutationObserver(rebuild);
        mo.observe(mine.parentElement, { childList: true });
        off.push(function () { mo.disconnect(); });
      }
      build();
      var onUnload = function (e) {
        if (e.target !== mine) return;
        off.forEach(function (fn) { fn(); }); off = [];
        document.removeEventListener('shopify:section:unload', onUnload);
      };
      document.addEventListener('shopify:section:unload', onUnload);
    }
    function init() { Object.keys(window.WU_CFG || {}).forEach(function (id) { if (id.indexOf('WuSecNav-') === 0) initOne(document.getElementById(id)); }); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
    document.addEventListener('shopify:section:load', init);
  })();
